import { render } from "./BuscaVeiculoAntt.vue?vue&type=template&id=7403f06e&scoped=true"
import script from "./BuscaVeiculoAntt.vue?vue&type=script&lang=ts"
export * from "./BuscaVeiculoAntt.vue?vue&type=script&lang=ts"

import "./BuscaVeiculoAntt.vue?vue&type=style&index=0&id=7403f06e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7403f06e"

export default script